export class PermissionDeniedError extends Error {
    readonly kind = 'PermissionDeniedError';
    constructor(message = 'Permiso denegado') {
        super(message);
    }
}
